import { useState, useMemo, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";
import "./NewAddVisitRecordForm.css";

import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from "@mui/material/OutlinedInput";
import Button from "@mui/material/Button";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import BasicDatePicker from "./Date-picker";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import MChat from "./MChat.jsx";

import MilestoneTrackerDoctorView from "./MilestoneTrackerDoctorView";
import VaccinationTrackerDoctorView from "./VaccinationTrackerDoctorView";
import {
  anyRedFlagValuesA,
  anyRedFlagValuesB,
  anyRedFlagValuesC,
  anyRedFlagValuesD,
  anyRedFlagValuesE,
  anyRedFlagValuesF,
  anyRedFlagValuesG,
  anyRedFlagValuesH,
  anyRedFlagValuesI,
  babyProofingValues,
  breastfeedingValues,
  earlyLearningOppertunityValuesA,
  earlyLearningOppertunityValuesB,
  earlyLearningOppertunityValuesC,
  earlyLearningOppertunityValuesD,
  earlyLearningOppertunityValuesE,
  earlyLearningOppertunityValuesF,
  earlyLearningOppertunityValuesG,
  earlyLearningOppertunityValuesH,
  earlyLearningOppertunityValuesI,
  feedingTeachniqueValues,
  nenotalReflexValues,
  powerValues,
  reflexesValues,
  responsiveCareGivingValuesA,
  responsiveCareGivingValuesB,
  responsiveCareGivingValuesC,
  responsiveCareGivingValuesD,
  responsiveCareGivingValuesE,
  responsiveCareGivingValuesF,
  responsiveCareGivingValuesG,
  responsiveCareGivingValuesH,
  responsiveCareGivingValuesI,
  weightGainValues,
  visionValuesC,
  visionValuesD,
  visionValuesE,
  visionValuesF,
  visionValuesG,
  visionValuesH,
  visionValuesI,
  hearingValuesC,
  hearingValuesD,
  hearingValuesE,
  hearingValuesF,
  hearingValuesG,
  hearingValuesH,
  hearingValuesI,
  responsiveCareGivingValuesJ,
  earlyLearningOppertunityValuesJ,
  anyRedFlagValuesJ,
} from "../constants/selectValues.js";
import axios from "axios";
import { formatDate } from "../util/getFormattedDate.js";
import { toast } from "react-toastify";
import { yesNoOptions } from "./selectOptionValues.js";
import NumberInput from "./ui/NumberInput.jsx";
import Loader from "./Loader.jsx";
import dayjs from "dayjs";
import { cleanEnglishOnly } from "../util/capitalize.js";

const NewAddVisitRecordForm = ({ providerType }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [childId, setChildId] = useState(null);
  const [parentId, setParentId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [visitData, setVisitData] = useState(null);
  const token = localStorage.getItem("s2stoken");
  console.log(providerType, "provider-type");

  const {
    id,
    docId,
    ageGroup,
    currentAge: paramAge,
    ageInDays,
    actualMonths,
    actualDays,
  } = useParams();

  const getFormattedDate = (date) => {
    if (!date) return null; // Handle undefined/null case

    const visitDate = new Date(date);
    return visitDate.toISOString().replace("T", " ").slice(0, 19) + " GMT";
  };
  const fetchChildFromPatient = async () => {
    const payload = {
      firstName: location.state.patient.first_name,
      lastName: location.state.patient.last_name,
      gender: location.state.patient.gender,
      dob: formatDate(location.state.patient.date_of_birth),
    };
    const fetchChildUrl = `${process.env.REACT_APP_BACKEND_URL}/api/get_patient_child_id`;
    const fetchChildoptions = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
    };
    try {
      const response = await axios.post(
        fetchChildUrl,
        payload,
        fetchChildoptions
      );

      const child = response.data.data;
      setChildId(child.child_id);
      setParentId(child.parent_id);
    } catch (err) {
      if (err?.response?.data?.message === "Token has expired") {
        localStorage.removeItem("s2stoken");
        navigate("/");
      }
      console.log("Error Fetching child error : ", err);
    }
  };

  useEffect(() => {
    fetchChildFromPatient();
  }, []);
  useEffect(() => {
    setVisitData(location.state?.visitData);
  }, [location.state?.visitData]);
  console.log("wellvisit visit data", visitData);
  const temperatureValues = [
    {
      value: "normal",
      label: "Normal",
    },
    {
      value: "hypothermia",
      label: "Hypothermia",
    },
    {
      value: "hyperthermia",
      label: "Hyperthermia",
    },
  ];

  const twoValues = [
    {
      value: "no",
      label: "No",
    },
    {
      value: "yes",
      label: "Yes",
    },
  ];

  const VISITRECORDSTATE = {
    ANTHROPOMETRY: 0,
    IMMUNIZATION: 1,
    MILSTONE: 2,
    MCHAT: 3,
    HEALTHSTATUS: 4,
    SYSTEMIC: 5,
    NUTRITION: 6,
    CHECKBOXES: 7,
    IMPRESSION: 8,
  };

  const ANTHROPOMETRYSTATE = {
    currentAge: Number(paramAge) || 0,
    weight: "",
    length: "",
    headCircumference: "",
    currentAgeInDays: Number(ageInDays) || 0,
  };

  const IMPRESSIONSTATE = {
    difficultyInMovement: "",
    stiffnessOfBody: "",
    seizures: "",
    impairedVision: "",
    impairedHearing: "",
    comments: "",
    followUpDate: null,
    delayedMilestones: "",
    regressionOfMilestones: "",
  };

  const HEALTHSTATUS = {
    heartRate: "",
    respirationRate: "",
    distress: "",
    temperature: "",
    dysmorphism: "",
    asymmetry: "",
    abnormalHeadSize: "",
    skinlesion: "",
    lbw: "",
    malnutrition: "",
    anyMurmur: "",
    anyEvidenceOfFailure: "",
    teethEruptingNormally: "",
  };

  const SYSTEMICSTATE = {
    anaemia: "",
    jaundice: "",
    vitamin_d_prophylaxis: "",
    bowelDisturbance: "",
    rickets: "",
    hepatoSplenomegaly: "",
    tone: [],
    neonatalReflexes: [],
    power: [],
    redReflex: "",
    ropScreen: "",
    oae: "",
    hearingArray: [],
    routineEyeCheckup: "",
    visionArray: [],
  };

  const TOOGLESTATE = {
    distress: false,
    dysmorphism: false,
    asymmetry: false,
    abnormalHeadSize: false,
    skinlesion: false,
    lbw: false,
    bowelDisturbance: false,
    hepatoSplenomegaly: false,
    babyProofing: false,
    signsOfNeglect: false,
    malnutrition: false,
    anyMurmur: false,
    anyEvidenceOfFailure: false,
    teethEruptingNormally: false,
  };

  const NUTRITIONSTATE = {
    breastFeeding: "",
    feedingTechnique: "",
    weightGain: "",
    babyProofing: "",
    signsOfNeglect: "",
    safeToys: "",
    adequateSupervision: "",
    anysafetyIssues: "",
    nutritonArray: "",
    feedingPlan: "",
    complimentaryFeedingAdequate: "",
    numberOfMeals: "",
    varietyInFoodItem: "",
  };

  const CHECKBOXESSTATE = {
    responsiveCareGiving: [],
    earlyLearningOppertunity: [],
    anyRedFlags: [],
  };

  useEffect(() => {
    setAnthromentary({
      currentAge: visitData?.patient_age_in_months || Number(paramAge) || 0,
      weight: visitData?.weight_kg || "",
      length: visitData?.height_cm || "",
      headCircumference: visitData?.head_circumference_cm || "",
      currentAgeInDays: visitData?.age_days || Number(ageInDays) || 0,
    });
    setHealth({
      heartRate: visitData?.heart_rate || "",
      respirationRate: visitData?.respiration_rate || "",
      distress: visitData?.distress || "",
      temperature: visitData?.temperature || "",
      dysmorphism: visitData?.dysmorphism || "",
      asymmetry: visitData?.asymmetry || "",
      abnormalHeadSize: visitData?.abnormal_head_size || "",
      skinlesion: visitData?.skin_lesion || "",
      lbw: visitData?.lbw || "",
      malnutrition: visitData?.malnutrition || "",
      anyMurmur: visitData?.any_murmur || "",
      anyEvidenceOfFailure: visitData?.any_evidence_of_failure || "",
      teethEruptingNormally: visitData?.teeth_erupting_normally || "",
    });
    setSystemic({
      anaemia: visitData?.anaemia || "",
      jaundice: visitData?.jaundice || "",
      vitamin_d_prophylaxis: visitData?.vitamin_d_prophylaxis || "",
      bowelDisturbance: visitData?.bowel_disturbance || "",
      rickets: visitData?.rickets || "",
      hepatoSplenomegaly: visitData?.hepato_splenomegaly || "",
      tone: visitData?.tone || [],
      neonatalReflexes: visitData?.neonatal_reflexes || [],
      power: visitData?.npower || [],
      redReflex: visitData?.red_reflex || "",
      ropScreen: visitData?.rop_screen || "",
      oae: visitData?.oae || "",
      hearingArray: visitData?.hearing || [],
      routineEyeCheckup: visitData?.routine_eye_checkup || "",
      visionArray: visitData?.vision || [],
    });
    setNutrition({
      breastFeeding: visitData?.breastfeeding || "",
      feedingTechnique: visitData?.feeding_technique || "",
      weightGain: visitData?.weight_gain || "",
      babyProofing: visitData?.baby_proofing || "",
      signsOfNeglect: visitData?.signs_of_neglect || "",
      safeToys: visitData?.safe_toys || "",
      adequateSupervision: visitData?.adequate_supervision || "",
      anysafetyIssues: visitData?.any_safety_issues || "",
      nutritonArray: visitData?.nutrition || "",
      feedingPlan: visitData?.feeding_plan || "",
      complimentaryFeedingAdequate:
        visitData?.complimentary_feeding_adequate || "",
      numberOfMeals: visitData?.number_of_meals || "",
      varietyInFoodItem: visitData?.variety_in_food_item || "",
    });
    setImpression({
      difficultyInMovement: visitData?.difficulty_in_movement || "",
      stiffnessOfBody: visitData?.stiffness_of_body || "",
      seizures: visitData?.seizures || "",
      impairedVision: visitData?.impaired_vision || "",
      impairedHearing: visitData?.impaired_hearing || "",
      regressionOfMilestones: visitData?.regression_of_milestones || "",
      comments: visitData?.notes || "",
      followUpDate:
        (visitData?.follow_up_date && dayjs(visitData?.follow_up_date)) || null,
      delayedMilestones:
        visitData?.delayed_milestones === "None"
          ? ""
          : visitData?.delayed_milestones || "",
    });
    setChecker({
      responsiveCareGiving: visitData?.responsive_care_giving || [],
      earlyLearningOppertunity: visitData?.early_learning_opportunity || [],
      anyRedFlags: visitData?.any_red_flags || [],
    });
    setToggle({
      distress:
        (visitData &&
          visitData?.distress !== "" &&
          visitData?.distress !== "no") ||
        false,
      dysmorphism:
        (visitData &&
          visitData?.dysmorphism !== "" &&
          visitData?.dysmorphism !== "no") ||
        false,
      asymmetry:
        (visitData &&
          visitData?.asymmetry !== "" &&
          visitData?.asymmetry !== "no") ||
        false,
      abnormalHeadSize:
        (visitData &&
          visitData?.abnormal_head_size !== "" &&
          visitData?.abnormal_head_size !== "no") ||
        false,
      skinlesion:
        (visitData &&
          visitData?.skin_lesion !== "" &&
          visitData?.skin_lesion !== "no") ||
        false,
      lbw:
        (visitData && visitData?.lbw !== "" && visitData?.lbw !== "no") ||
        false,
      bowelDisturbance:
        (visitData &&
          visitData?.bowel_disturbance !== "" &&
          visitData?.bowel_disturbance !== "no") ||
        false,
      hepatoSplenomegaly:
        (visitData &&
          visitData?.hepato_splenomegaly !== "" &&
          visitData?.hepato_splenomegaly !== "no") ||
        false,
      babyProofing:
        (visitData &&
          visitData?.baby_proofing !== "" &&
          visitData?.baby_proofing !== "adequate") ||
        false,
      signsOfNeglect:
        (visitData &&
          visitData?.signs_of_neglect !== "" &&
          visitData?.signs_of_neglect !== "no") ||
        false,
      malnutrition:
        (visitData &&
          visitData?.malnutrition !== "" &&
          visitData?.malnutrition !== "no") ||
        false,
      anyMurmur:
        (visitData &&
          visitData?.any_murmur !== "" &&
          visitData?.any_murmur !== "no") ||
        false,
      anyEvidenceOfFailure:
        (visitData &&
          visitData?.any_evidence_of_failure !== "" &&
          visitData?.any_evidence_of_failure !== "no") ||
        false,
      teethEruptingNormally:
        (visitData &&
          visitData?.teeth_erupting_normally !== "" &&
          visitData?.teeth_erupting_normally !== "no") ||
        false,
    });
  }, [visitData]);
  const ANSWERSTATE = {
    q1: "",
    q2: "",
    q3: "",
    q4: "",
    q5: "",
    q6: "",
    q7: "",
    q8: "",
    q9: "",
    q10: "",
    q11: "",
    q12: "",
    q13: "",
    q14: "",
    q15: "",
    q16: "",
    q17: "",
    q18: "",
    q19: "",
    q20: "",
  };
  const specialYesQuestions = ["q2", "q5", "q12"];

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  const toneValues = ["Hypertonic", "Hypotonic", "Normal"];

  const [step, setStep] = useState(VISITRECORDSTATE.ANTHROPOMETRY);
  const [health, setHealth] = useState(HEALTHSTATUS);
  const [systemic, setSystemic] = useState(SYSTEMICSTATE);
  const [nutriton, setNutrition] = useState(NUTRITIONSTATE);
  const [checker, setChecker] = useState(CHECKBOXESSTATE);
  const [impression, setImpression] = useState(IMPRESSIONSTATE);
  const [anthromentary, setAnthromentary] = useState(ANTHROPOMETRYSTATE);
  const [toggle, setToggle] = useState(TOOGLESTATE);
  const [mchatAnsCount, setMchatAnsCount] = useState(0);
  const [answers, setAnswers] = useState(ANSWERSTATE);
  const [mchatScore, setMchatScore] = useState(0);

  const handleAnswerChange = (questionId, answer) => {
    console.log(questionId, answer, "questionId, answer");
    const updatedAnswers = { ...answers, [`q${questionId}`]: answer };
    console.log(updatedAnswers, "updatedAnswers");

    // Calculate new score
    let newScore = 0;
    Object.keys(updatedAnswers).forEach((key) => {
      if (specialYesQuestions.includes(key) && updatedAnswers[key] === "yes") {
        newScore++;
      } else if (
        !specialYesQuestions.includes(key) &&
        updatedAnswers[key] === "no"
      ) {
        newScore++;
      }
    });

    setAnswers(updatedAnswers);
    setMchatScore(newScore);
  };
  function getDateTime() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  const handleVisitRecordSubmit = async () => {
    let mchatResult = "";
    if (Number(paramAge) >= 18) {
      if (mchatScore <= 2) {
        mchatResult = "Low Risk";
      } else if (mchatScore >= 3 && mchatScore <= 8) {
        mchatResult = "Moderate Risk";
      } else {
        mchatResult = "High Risk";
      }
    }
    const mchatPayload = {
      patientId: id,
      pediatricianId: docId,
      currentAge: paramAge,
      mchatScore: mchatScore,
      mchatResult: mchatResult,
      ...answers,
    };

    const payload = {
      patientId: id,
      pediatricianId: docId,
      ...anthromentary,
      visitDateTime: getDateTime(),
      ...health,
      skinLesion: health.skinlesion,
      temperature: health.temperature,
      ...nutriton,
      nutriton: nutriton.nutritonArray,
      hearing: systemic.hearingArray,
      vision: systemic.visionArray,
      ...impression,
      followUpDate: impression.followUpDate
        ? new Date(impression.followUpDate).toLocaleDateString("en-CA")
        : null,
      ...systemic,
      ...checker,
      notes: impression.comments,
      gestationalAgeInMonths: actualMonths,
      gestationalAgeInDays:
        Number(actualDays) !== 0 ? actualDays.split(" ")[0] : 0,
    };

    const updateVisitRecordPayload = {
      abnormal_head_size: health.abnormalHeadSize,
      adequate_supervision: nutriton.adequateSupervision,
      age_days: Number(anthromentary.currentAgeInDays) || 0,
      anaemia: systemic.anaemia,
      any_evidence_of_failure: health.anyEvidenceOfFailure,
      any_murmur: health.anyMurmur,
      any_red_flags: checker.anyRedFlags,
      any_safety_issues: nutriton.anysafetyIssues,
      asymmetry: health.asymmetry,
      baby_proofing: nutriton.babyProofing,
      bowel_disturbance: systemic.bowelDisturbance,
      breastfeeding: nutriton.breastFeeding,
      complimentary_feeding_adequate: nutriton.complimentaryFeedingAdequate,
      delayed_milestones: impression.delayedMilestones,
      difficulty_in_movement: impression.difficultyInMovement,
      distress: health.distress,
      doctor_id: docId,
      dysmorphism: health.dysmorphism,
      early_learning_opportunity: checker.earlyLearningOppertunity,
      feeding_plan: nutriton.feedingPlan,
      feeding_technique: nutriton.feedingTechnique,
      follow_up_date: impression.followUpDate
        ? new Date(impression.followUpDate).toLocaleDateString("en-CA")
        : null,
      gestational_age_in_days: Number(visitData?.gestational_age_in_days) || 0,
      gestational_age_in_months: Number(visitData?.gestationalAgeInMonths) || 0,
      head_circumference_cm: Number(anthromentary.headCircumference) || 0,
      hearing: systemic.hearingArray,
      heart_rate: Number(health.heartRate) || 0,
      height_cm: Number(anthromentary.length) || 0,
      hepato_splenomegaly: systemic.hepatoSplenomegaly,
      impaired_hearing: impression.impairedHearing,
      impaired_vision: impression.impairedVision,
      jaundice: systemic.jaundice,
      lbw: health.lbw,
      malnutrition: health.malnutrition,
      neonatal_reflexes: systemic.neonatalReflexes,
      notes: impression.comments,
      npower: systemic.power,
      number_of_meals: Number(nutriton.numberOfMeals) || 0,
      oae: systemic.oae,
      patient_age_in_months: Number(visitData?.patient_age_in_months) || 0,
      patient_id: id,
      red_reflex: systemic.redReflex,
      respiration_rate: Number(health.respirationRate) || 0,
      responsive_care_giving: checker.responsiveCareGiving,
      rickets: systemic.rickets,
      rop_screen: systemic.ropScreen,
      safe_toys: nutriton.safeToys,
      seizures: impression.seizures,
      signs_of_neglect: nutriton.signsOfNeglect,
      skin_lesion: health.skinlesion,
      stiffness_of_body: impression.stiffnessOfBody,
      teeth_erupting_normally: health.teethEruptingNormally,
      temperature: health.temperature,
      tone: systemic.tone,
      variety_in_food_item: nutriton.varietyInFoodItem,
      vision: systemic.visionArray,
      routine_eye_checkup: systemic.routineEyeCheckup,
      visit_date_time: visitData?.visit_date_time
        ? getFormattedDate(visitData.visit_date_time)
        : null,
      vitamin_d_prophylaxis: systemic.vitamin_d_prophylaxis,
      weight_gain: nutriton.weightGain,
      weight_kg: Number(anthromentary.weight) || 0,
      regression_of_milestones: impression.regressionOfMilestones,
    };

    console.log(payload);
    console.log("update visit record payload", updateVisitRecordPayload);

    try {
      const url1 = `${process.env.REACT_APP_BACKEND_URL}/api/create_mchat`;
      const url2 = `${process.env.REACT_APP_BACKEND_URL}/api/add_visit_record_by_doctor`;
      const url3 = `${process.env.REACT_APP_BACKEND_URL}/api/update_visit_record/${visitData?.visit_id}`;

      const requests = [];

      if (visitData !== null) {
        requests.push(
          axios.put(url3, updateVisitRecordPayload, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            withCredentials: true,
          })
        );
      } else {
        requests.push(
          axios.post(url2, payload, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            withCredentials: true,
          })
        );
      }
      if (Number(paramAge) >= 18) {
        requests.push(
          axios.post(url1, mchatPayload, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            withCredentials: true,
          })
        );
      }
      setLoading(true);
      const responses = await Promise.all(requests);

      const visitResponse = responses[0];
      const mchatResponse = responses.length > 1 ? responses[1] : null;
      console.table(visitResponse.data);

      if (mchatResponse) {
        console.log("MCHAT Response:", mchatResponse.data);
      } else {
        console.log("MCHAT Response: Not applicable (age outside range)");
      }
      console.log("Visit Record Response:", visitResponse.data);
      if (visitResponse?.data?.success) {
        if (visitData !== null) {
          toast.success("Wellness visit record updated successfully");
        } else {
          toast.success("Wellness visit record added successfully");
        }
      }

      if (mchatResponse && mchatResponse.data.success) {
        toast.success("MCHAT Submitted Successfully");
      }
    } catch (error) {
      setLoading(false);
      if (error?.response?.data?.message === "Token has expired") {
        localStorage.removeItem("s2stoken");
        navigate("/");
      }
      console.error("Error:", error);
      const errorMessage = "An unexpected error occurred. Please try again.";

      toast.error(errorMessage);
    } finally {
      setLoading(false);
      navigate(`/new-patient-profile/${id}/${docId}`);
    }
  };

  const validateAnthropometry = () => {
    if (!anthromentary.weight.trim()) {
      toast.warn("Please enter Weight");
      return false;
    }
    if (!anthromentary.length.trim()) {
      toast.warn("Please enter Length");
      return false;
    }
    if (!anthromentary.headCircumference.trim()) {
      toast.warn("Please enter Head Circumference");
      return false;
    }
    return true;
  };

  function handleAnthropometryChange(e) {
    const { name, value } = e.target;
    const numValue = Number(value);

    if (["weight", "length", "headCircumference"].includes(name)) {
      if (isNaN(numValue) || numValue < 0) {
        return toast.warn(`${name} must be a positive number`);
      }
    }
    setAnthromentary((prev) => ({
      ...prev,
      [name]: value,
    }));
  }

  function handleHelthStatusChange(e) {
    const { name, value } = e.target;
    if (name === "heartRate" && isNaN(value)) {
      return toast.warn("Heart rate must be a positive integer");
    }
    if (name === "respirationRate" && isNaN(value)) {
      return toast.warn("Respiration rate must be a positive integer");
    }
    setHealth((prev) => ({
      ...prev,
      [name]: cleanEnglishOnly(value),
    }));
  }
  function handleNutritionChange(e) {
    const { name, value } = e.target;
    if (name === "numberOfMeals" && isNaN(value)) {
      return toast.warn("Number of meals must be a positive integer");
    }
    setNutrition((prev) => ({
      ...prev,
      [name]: cleanEnglishOnly(value),
    }));
  }
  const incrementStep = () => {
    if (
      step === VISITRECORDSTATE.HEALTHSTATUS &&
      toggle.anyMurmur &&
      health.anyMurmur.trim() === ""
    ) {
      return toast.warn("Please specify murmur");
    }
    if (
      step === VISITRECORDSTATE.HEALTHSTATUS &&
      toggle.anyEvidenceOfFailure &&
      health.anyEvidenceOfFailure.trim() === ""
    ) {
      return toast.warn("Please specify evidence of failure");
    }
    if (
      step === VISITRECORDSTATE.HEALTHSTATUS &&
      toggle.distress &&
      health.distress.trim() === ""
    ) {
      return toast.warn("Please specify any distress");
    }
    if (
      step === VISITRECORDSTATE.HEALTHSTATUS &&
      toggle.dysmorphism &&
      health.dysmorphism.trim() === ""
    ) {
      return toast.warn("Please specify dysmorphism");
    }
    if (
      step === VISITRECORDSTATE.HEALTHSTATUS &&
      toggle.abnormalHeadSize &&
      health.abnormalHeadSize.trim() === ""
    ) {
      return toast.warn("Please specify abnormal head size");
    }
    if (
      step === VISITRECORDSTATE.HEALTHSTATUS &&
      toggle.asymmetry &&
      health.asymmetry.trim() === ""
    ) {
      return toast.warn("Please specify asymmetry");
    }
    if (
      step === VISITRECORDSTATE.HEALTHSTATUS &&
      toggle.skinlesion &&
      health.skinlesion.trim() === ""
    ) {
      return toast.warn("Please specify skin lesion");
    }
    if (
      step === VISITRECORDSTATE.HEALTHSTATUS &&
      toggle.teethEruptingNormally &&
      health.teethEruptingNormally.trim() === ""
    ) {
      return toast.warn("Please specify teeth erupting abnormally");
    }
    if (
      step === VISITRECORDSTATE.HEALTHSTATUS &&
      toggle.malnutrition &&
      health.malnutrition.trim() === ""
    ) {
      return toast.warn("Please specify malnutrition");
    }
    if (
      step === VISITRECORDSTATE.HEALTHSTATUS &&
      toggle.lbw &&
      health.lbw.trim() === ""
    ) {
      return toast.warn("Please specify lbw");
    }
    if (
      step === VISITRECORDSTATE.SYSTEMIC &&
      toggle.hepatoSplenomegaly &&
      systemic.hepatoSplenomegaly.trim() === ""
    ) {
      return toast.warn("Please specify hepato splenomegaly");
    }
    if (
      step === VISITRECORDSTATE.SYSTEMIC &&
      toggle.bowelDisturbance &&
      systemic.bowelDisturbance.trim() === ""
    ) {
      return toast.warn("Please specify bowel disturbance");
    }
    if (
      step === VISITRECORDSTATE.NUTRITION &&
      toggle.babyProofing &&
      nutriton.babyProofing.trim() === ""
    ) {
      return toast.warn("Please specify baby proofing");
    }
    if (
      step === VISITRECORDSTATE.NUTRITION &&
      toggle.signsOfNeglect &&
      nutriton.signsOfNeglect.trim() === ""
    ) {
      return toast.warn("Please specify signs of neglect");
    }
    if (step === VISITRECORDSTATE.IMPRESSION) {
      handleVisitRecordSubmit();
      return;
    }
    if (step === VISITRECORDSTATE.ANTHROPOMETRY && !validateAnthropometry()) {
      return;
    }
    if (
      step === VISITRECORDSTATE.MILSTONE &&
      Number(paramAge) <= 17 &&
      providerType === "health_worker"
    ) {
      return setStep((prevStep) => {
        const nextStep = Math.min(VISITRECORDSTATE.IMPRESSION, prevStep + 3);
        window.scrollTo({ top: 0, behavior: "smooth" });
        return nextStep;
      });
    }
    if (step === VISITRECORDSTATE.MILSTONE && Number(paramAge) <= 17) {
      return setStep((prevStep) => {
        const nextStep = Math.min(VISITRECORDSTATE.IMPRESSION, prevStep + 2);
        window.scrollTo({ top: 0, behavior: "smooth" });
        return nextStep;
      });
    }
    if (step === VISITRECORDSTATE.MCHAT && mchatAnsCount !== 20) {
      return toast.warn("Please answer all questions");
    }
    if (step === VISITRECORDSTATE.MCHAT && providerType === "health_worker") {
      return setStep((prevStep) => {
        const nextStep = Math.min(VISITRECORDSTATE.IMPRESSION, prevStep + 2);
        window.scrollTo({ top: 0, behavior: "smooth" });
        return nextStep;
      });
    }
    setStep((prevStep) => {
      const nextStep = Math.min(VISITRECORDSTATE.IMPRESSION, prevStep + 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
      return nextStep;
    });
  };

  const decrementStep = () => {
    if (
      step === VISITRECORDSTATE.SYSTEMIC &&
      Number(paramAge) <= 17 &&
      providerType === "health_worker"
    ) {
      return setStep((prevStep) => {
        const nextStep = Math.min(VISITRECORDSTATE.IMPRESSION, prevStep - 3);
        window.scrollTo({ top: 0, behavior: "smooth" });
        return nextStep;
      });
    }
    if (step === VISITRECORDSTATE.HEALTHSTATUS && Number(paramAge) <= 17) {
      return setStep((prevStep) => {
        const prev = Math.min(VISITRECORDSTATE.IMPRESSION, prevStep - 2);
        window.scrollTo({ top: 0, behavior: "smooth" });
        return prev;
      });
    }
    if (
      step === VISITRECORDSTATE.SYSTEMIC &&
      providerType === "health_worker"
    ) {
      return setStep((prevStep) => {
        const nextStep = Math.min(VISITRECORDSTATE.IMPRESSION, prevStep - 2);
        window.scrollTo({ top: 0, behavior: "smooth" });
        return nextStep;
      });
    }
    setStep((prevStep) => {
      const prev = Math.max(VISITRECORDSTATE.ANTHROPOMETRY, prevStep - 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
      return prev;
    });
  };

  const actionLabel = useMemo(() => {
    console.log(step === VISITRECORDSTATE.IMPRESSION);
    return step === VISITRECORDSTATE.IMPRESSION ? "Submit" : "Next";
  }, [step, VISITRECORDSTATE.IMPRESSION]);

  const secondaryActionLabel = useMemo(() => {
    if (step === VISITRECORDSTATE.ANTHROPOMETRY) {
      return undefined;
    }
    return "Back";
  }, [VISITRECORDSTATE.ANTHROPOMETRY, step]);

  console.log("step:", step, "label:", actionLabel);

  let anthropometry = (
    <div className={"formMain"}>
      <h2>Anthropometry</h2>
      <div className={"formSection"}>
        <TextField
          id="currentAgeInMonths"
          name="currentAgeInMonths"
          label={
            paramAge === "0" ? "Actual Age in Days" : "Actual Age in Months"
          }
          variant="outlined"
          size="small"
          value={
            anthromentary?.currentAge === 0
              ? anthromentary?.currentAgeInDays
              : anthromentary?.currentAge
          }
          slotProps={{
            input: {
              readOnly: true,
            },
          }}
        />
        {Number(paramAge) <= 24 && (
          <TextField
            name="adjustedAgeInMonths"
            label={
              actualMonths === "0"
                ? "Adjusted Age in Days"
                : "Adjusted Age in Months"
            }
            variant="outlined"
            size="small"
            value={
              actualDays !== "0"
                ? actualMonths === 0 || actualMonths === "0"
                  ? actualDays
                  : actualMonths
                : "N/A"
            }
            slotProps={{
              input: {
                readOnly: true,
              },
            }}
          />
        )}
        <NumberInput
          id="weight"
          name="weight"
          label="Weight in kg (e.g. 10)"
          required
          value={anthromentary.weight}
          onChange={handleAnthropometryChange}
        />
      </div>
      <div className="formSection">
        <NumberInput
          id="length"
          name="length"
          label="Length in cm (e.g. 20)"
          required
          value={anthromentary.length}
          onChange={handleAnthropometryChange}
        />
        <NumberInput
          id="headCircumference"
          name="headCircumference"
          label="Head Circumference in cm"
          required
          value={anthromentary.headCircumference}
          onChange={handleAnthropometryChange}
        />
      </div>
    </div>
  );

  let healthStatus = (
    <div className="formMain">
      <div>
        <h2>Health Status</h2>
      </div>
      <div className="formSection">
        <NumberInput
          id="heartRate"
          name="heartRate"
          label="Heart Rate (beats per min)"
          value={health.heartRate}
          onChange={handleHelthStatusChange}
        />
        {(ageGroup === "C" ||
          ageGroup === "D" ||
          ageGroup === "E" ||
          ageGroup === "F" ||
          ageGroup === "G" ||
          ageGroup === "H" ||
          ageGroup === "I" ||
          ageGroup === "J") && (
          <>
            <TextField
              id="anyMurmur"
              name="anyMurmur"
              select
              size="small"
              label="Any murmur ?"
              variant="outlined"
              sx={{ backgroundColor: "#3071FF21" }}
              value={toggle.anyMurmur ? "yes" : health.anyMurmur}
              onChange={(e) => {
                const value = e.target.value;
                if (value === "yes") {
                  setToggle((prevToggle) => ({
                    ...prevToggle,
                    anyMurmur: true,
                  }));
                  setHealth((prevBirth) => ({
                    ...prevBirth,
                    anyMurmur: "",
                  }));
                } else {
                  setToggle((prevToggle) => ({
                    ...prevToggle,
                    anyMurmur: false,
                  }));
                  setHealth((prevBirth) => ({
                    ...prevBirth,
                    anyMurmur: "no",
                  }));
                }
              }}
            >
              {twoValues.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
            {toggle.anyMurmur && (
              <TextField
                id="anyMurmur"
                name="anyMurmur"
                label="Specify any murmur"
                variant="outlined"
                size="small"
                value={health.anyMurmur}
                onChange={handleHelthStatusChange}
              />
            )}
            <TextField
              id="anyEvidenceOfFailure"
              name="anyEvidenceOfFailure"
              select
              label="Any evidence of failure ?"
              variant="outlined"
              size="small"
              sx={{ backgroundColor: "#3071FF21" }}
              value={
                toggle.anyEvidenceOfFailure
                  ? "yes"
                  : health.anyEvidenceOfFailure
              }
              onChange={(e) => {
                const value = e.target.value;
                if (value === "yes") {
                  setToggle((prevToggle) => ({
                    ...prevToggle,
                    anyEvidenceOfFailure: true,
                  }));
                  setHealth((prevBirth) => ({
                    ...prevBirth,
                    anyEvidenceOfFailure: "",
                  }));
                } else {
                  setToggle((prevToggle) => ({
                    ...prevToggle,
                    anyEvidenceOfFailure: false,
                  }));
                  setHealth((prevBirth) => ({
                    ...prevBirth,
                    anyEvidenceOfFailure: "no",
                  }));
                }
              }}
            >
              {twoValues.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
            {toggle.anyEvidenceOfFailure && (
              <TextField
                id="anyEvidenceOfFailure"
                name="anyEvidenceOfFailure"
                label="Specify any evidence of failure"
                variant="outlined"
                size="small"
                value={health.anyEvidenceOfFailure}
                onChange={handleHelthStatusChange}
              />
            )}
          </>
        )}

        <NumberInput
          id="respirationRate"
          name="respirationRate"
          label="Respiration Rate (breaths per min)"
          value={health.respirationRate}
          onChange={handleHelthStatusChange}
        />
        <TextField
          id="distress"
          name="distress"
          select
          label="Respiratory Distress"
          variant="outlined"
          size="small"
          sx={{ backgroundColor: "#3071FF21" }}
          value={toggle.distress ? "yes" : health.distress}
          onChange={(e) => {
            const value = e.target.value;
            if (value === "yes") {
              setToggle((prevToggle) => ({
                ...prevToggle,
                distress: true,
              }));
              setHealth((prevBirth) => ({
                ...prevBirth,
                distress: "",
              }));
            } else {
              setToggle((prevToggle) => ({
                ...prevToggle,
                distress: false,
              }));
              setHealth((prevBirth) => ({
                ...prevBirth,
                distress: "no",
              }));
            }
          }}
        >
          {twoValues.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
        {toggle.distress && (
          <TextField
            id="distress"
            name="distress"
            label="Specify Respiratory Distress"
            variant="outlined"
            size="small"
            value={health.distress}
            onChange={handleHelthStatusChange}
          />
        )}
        <TextField
          id="temperature"
          name="temperature"
          select
          label="Select Temperature"
          value={health.temperature}
          variant="outlined"
          size="small"
          sx={{ backgroundColor: "#3071FF21" }}
          onChange={handleHelthStatusChange}
        >
          {temperatureValues.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </div>
      <div className={"healthFormSection"}>
        {(ageGroup === "C" ||
          ageGroup === "D" ||
          ageGroup === "E" ||
          ageGroup === "F" ||
          ageGroup === "G" ||
          ageGroup === "H" ||
          ageGroup === "I" ||
          ageGroup === "J") && (
          <>
            <TextField
              id="dysmorphism"
              name="dysmorphism"
              select
              label="Dysmorphism"
              variant="outlined"
              size="small"
              sx={{ backgroundColor: "#3071FF21" }}
              value={toggle.dysmorphism ? "yes" : health.dysmorphism}
              onChange={(e) => {
                const value = e.target.value;
                if (value === "yes") {
                  setToggle((prevToggle) => ({
                    ...prevToggle,
                    dysmorphism: true,
                  }));
                  setHealth((prevBirth) => ({
                    ...prevBirth,
                    dysmorphism: "",
                  }));
                } else {
                  setToggle((prevToggle) => ({
                    ...prevToggle,
                    dysmorphism: false,
                  }));
                  setHealth((prevBirth) => ({
                    ...prevBirth,
                    dysmorphism: "no",
                  }));
                }
              }}
            >
              {twoValues.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
            {toggle.dysmorphism && (
              <TextField
                id="dysmorphism"
                name="dysmorphism"
                label="Specify Dysmorphism"
                variant="outlined"
                size="small"
                value={health.dysmorphism}
                onChange={handleHelthStatusChange}
              />
            )}

            <TextField
              id="asymmetry"
              name="asymmetry"
              select
              label="Asymmetry"
              variant="outlined"
              size="small"
              sx={{ backgroundColor: "#3071FF21" }}
              value={toggle.asymmetry ? "yes" : health.asymmetry}
              onChange={(e) => {
                const value = e.target.value;
                if (value === "yes") {
                  setToggle((prevToggle) => ({
                    ...prevToggle,
                    asymmetry: true,
                  }));
                  setHealth((prevBirth) => ({
                    ...prevBirth,
                    asymmetry: "",
                  }));
                } else {
                  setToggle((prevToggle) => ({
                    ...prevToggle,
                    asymmetry: false,
                  }));
                  setHealth((prevBirth) => ({
                    ...prevBirth,
                    asymmetry: "no",
                  }));
                }
              }}
            >
              {twoValues.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
            {toggle.asymmetry && (
              <TextField
                id="asymmetry"
                name="asymmetry"
                label="Specify Asymmetry"
                variant="outlined"
                size="small"
                value={health.asymmetry}
                onChange={handleHelthStatusChange}
              />
            )}
            <TextField
              id="abnormalHeadSize"
              name="abnormalHeadSize"
              select
              label="Abnormal Head Size"
              variant="outlined"
              size="small"
              sx={{ backgroundColor: "#3071FF21" }}
              value={toggle.abnormalHeadSize ? "yes" : health.abnormalHeadSize}
              onChange={(e) => {
                const value = e.target.value;
                if (value === "yes") {
                  setToggle((prevToggle) => ({
                    ...prevToggle,
                    abnormalHeadSize: true,
                  }));
                  setHealth((prevBirth) => ({
                    ...prevBirth,
                    abnormalHeadSize: "",
                  }));
                } else {
                  setToggle((prevToggle) => ({
                    ...prevToggle,
                    abnormalHeadSize: false,
                  }));
                  setHealth((prevBirth) => ({
                    ...prevBirth,
                    abnormalHeadSize: "no",
                  }));
                }
              }}
            >
              {twoValues.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
            {toggle.abnormalHeadSize && (
              <TextField
                id="abnormalHeadSize"
                name="abnormalHeadSize"
                label="Specify Abnormal Head Size"
                variant="outlined"
                size="small"
                value={health.abnormalHeadSize}
                onChange={handleHelthStatusChange}
              />
            )}
            <TextField
              id="skinlesion"
              name="skinlesion"
              select
              label="Skin Lesion"
              variant="outlined"
              size="small"
              sx={{ backgroundColor: "#3071FF21" }}
              value={toggle.skinlesion ? "yes" : health.skinlesion}
              onChange={(e) => {
                const value = e.target.value;
                if (value === "yes") {
                  setToggle((prevToggle) => ({
                    ...prevToggle,
                    skinlesion: true,
                  }));
                  setHealth((prevBirth) => ({
                    ...prevBirth,
                    skinlesion: "",
                  }));
                } else {
                  setToggle((prevToggle) => ({
                    ...prevToggle,
                    skinlesion: false,
                  }));
                  setHealth((prevBirth) => ({
                    ...prevBirth,
                    skinlesion: "no",
                  }));
                }
              }}
            >
              {twoValues.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
            {toggle.skinlesion && (
              <TextField
                id="skinlesion"
                name="skinlesion"
                label="Specify Skin Lesion"
                variant="outlined"
                size="small"
                value={health.skinlesion}
                onChange={handleHelthStatusChange}
              />
            )}

            {(ageGroup === "E" ||
              ageGroup === "F" ||
              ageGroup === "G" ||
              ageGroup === "H" ||
              ageGroup === "I" ||
              ageGroup === "J") && (
              <>
                <TextField
                  id="anyMurmur"
                  name="anyMurmur"
                  select
                  size="small"
                  label="Teeth erupting abnormally?"
                  variant="outlined"
                  sx={{ backgroundColor: "#3071FF21" }}
                  value={
                    toggle.teethEruptingNormally
                      ? "yes"
                      : health.teethEruptingNormally
                  }
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "yes") {
                      setToggle((prevToggle) => ({
                        ...prevToggle,
                        teethEruptingNormally: true,
                      }));
                      setHealth((prevBirth) => ({
                        ...prevBirth,
                        teethEruptingNormally: "",
                      }));
                    } else {
                      setToggle((prevToggle) => ({
                        ...prevToggle,
                        teethEruptingNormally: false,
                      }));
                      setHealth((prevBirth) => ({
                        ...prevBirth,
                        teethEruptingNormally: "no",
                      }));
                    }
                  }}
                >
                  {twoValues.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
                {toggle.teethEruptingNormally && (
                  <TextField
                    id="teethEruptingNormally"
                    name="teethEruptingNormally"
                    label="Specify teeth erupting abnormality"
                    variant="outlined"
                    size="small"
                    value={health.teethEruptingNormally}
                    onChange={handleHelthStatusChange}
                  />
                )}
              </>
            )}
          </>
        )}
        {ageGroup === "A" && (
          <>
            <TextField
              id="lbw"
              name="lbw"
              select
              label="Evidence of IUGR/ LBW/ prematurity ?"
              variant="outlined"
              size="small"
              sx={{ backgroundColor: "#3071FF21" }}
              value={toggle.lbw ? "yes" : health.lbw}
              onChange={(e) => {
                const value = e.target.value;
                if (value === "yes") {
                  setToggle((prevToggle) => ({
                    ...prevToggle,
                    lbw: true,
                  }));
                  setHealth((prevBirth) => ({
                    ...prevBirth,
                    lbw: "",
                  }));
                } else {
                  setToggle((prevToggle) => ({
                    ...prevToggle,
                    lbw: false,
                  }));
                  setHealth((prevBirth) => ({
                    ...prevBirth,
                    lbw: "no",
                  }));
                }
              }}
            >
              {twoValues.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
            {toggle.lbw && (
              <TextField
                id="lbw"
                name="lbw"
                label="Specify Evidence of IUGR/ LBW/ prematurity"
                variant="outlined"
                size="small"
                value={health.lbw}
                onChange={handleHelthStatusChange}
              />
            )}
          </>
        )}
        {ageGroup !== "A" && (
          <>
            <TextField
              id="malnutrition"
              name="malnutrition"
              select
              label="Malnutrition"
              variant="outlined"
              size="small"
              sx={{ backgroundColor: "#3071FF21" }}
              value={toggle.malnutrition ? "yes" : health.malnutrition}
              onChange={(e) => {
                const value = e.target.value;
                if (value === "yes") {
                  setToggle((prevToggle) => ({
                    ...prevToggle,
                    malnutrition: true,
                  }));
                  setHealth((prevBirth) => ({
                    ...prevBirth,
                    malnutrition: "",
                  }));
                } else {
                  setToggle((prevToggle) => ({
                    ...prevToggle,
                    malnutrition: false,
                  }));
                  setHealth((prevBirth) => ({
                    ...prevBirth,
                    malnutrition: "no",
                  }));
                }
              }}
            >
              {twoValues.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
            {toggle.malnutrition && (
              <TextField
                id="malnutrition"
                name="malnutrition"
                label="Specify Malnutrition"
                variant="outlined"
                size="small"
                value={health.malnutrition}
                onChange={handleHelthStatusChange}
              />
            )}
          </>
        )}
      </div>
    </div>
  );

  let systemicStatus = (
    <div className="formMain">
      {providerType !== "health_worker" && (
        <>
          <div>
            <h2>Systemic</h2>
          </div>
          <div className="systemicFormSection">
            <TextField
              id="anaemia"
              name="anaemia"
              select
              label="Anemia"
              variant="outlined"
              size="small"
              sx={{ backgroundColor: "#3071FF21" }}
              value={systemic.anaemia}
              onChange={(e) => {
                const val = e.target.value;
                setSystemic((prev) => ({
                  ...prev,
                  anaemia: cleanEnglishOnly(val),
                }));
              }}
            >
              {twoValues.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
            {!(ageGroup === "G" || ageGroup === "H" || ageGroup === "I") && (
              <TextField
                id="jaundice"
                name="jaundice"
                select
                label="Jaundice"
                variant="outlined"
                size="small"
                sx={{ backgroundColor: "#3071FF21" }}
                value={systemic.jaundice}
                onChange={(e) => {
                  const val = e.target.value;
                  setSystemic((prev) => ({
                    ...prev,
                    jaundice: cleanEnglishOnly(val),
                  }));
                }}
              >
                {twoValues.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            )}
            {(ageGroup === "C" ||
              ageGroup === "D" ||
              ageGroup === "E" ||
              ageGroup === "F") && (
              <>
                <TextField
                  id="vitamin_d_prophylaxis"
                  name="vitamin_d_prophylaxis"
                  select
                  label="Vitamin D prophylaxis"
                  variant="outlined"
                  size="small"
                  sx={{ backgroundColor: "#3071FF21" }}
                  value={systemic.vitamin_d_prophylaxis}
                  onChange={(e) => {
                    const val = e.target.value;
                    setSystemic((prev) => ({
                      ...prev,
                      vitamin_d_prophylaxis: cleanEnglishOnly(val),
                    }));
                  }}
                >
                  {twoValues.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </>
            )}
            {(ageGroup === "D" ||
              ageGroup === "E" ||
              ageGroup === "F" ||
              ageGroup === "G" ||
              ageGroup === "H" ||
              ageGroup === "I" ||
              ageGroup === "J") && (
              <TextField
                id="rickets"
                name="rickets"
                select
                label="Rickets"
                variant="outlined"
                size="small"
                sx={{ backgroundColor: "#3071FF21" }}
                value={systemic.rickets}
                onChange={(e) => {
                  const val = e.target.value;
                  setSystemic((prev) => ({
                    ...prev,
                    rickets: val,
                  }));
                }}
              >
                {twoValues.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            )}
          </div>
          <div className="healthFormSection">
            <TextField
              id="hepatoSplenomegaly"
              name="hepatoSplenomegaly"
              select
              label="Hepato Splenomegaly"
              variant="outlined"
              size="small"
              sx={{ backgroundColor: "#3071FF21" }}
              value={
                toggle.hepatoSplenomegaly ? "yes" : systemic.hepatoSplenomegaly
              }
              onChange={(e) => {
                const value = e.target.value;
                if (value === "yes") {
                  setToggle((prevToggle) => ({
                    ...prevToggle,
                    hepatoSplenomegaly: true,
                  }));
                  setSystemic((prevBirth) => ({
                    ...prevBirth,
                    hepatoSplenomegaly: "",
                  }));
                } else {
                  setToggle((prevToggle) => ({
                    ...prevToggle,
                    hepatoSplenomegaly: false,
                  }));
                  setSystemic((prevBirth) => ({
                    ...prevBirth,
                    hepatoSplenomegaly: "no",
                  }));
                }
              }}
            >
              {twoValues.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
            {toggle.hepatoSplenomegaly && (
              <TextField
                id="hepatoSplenomegaly"
                name="hepatoSplenomegaly"
                label="Specify Hepato Splenomegaly"
                variant="outlined"
                value={systemic.hepatoSplenomegaly}
                onChange={(e) => {
                  setSystemic((prev) => ({
                    ...prev,
                    hepatoSplenomegaly: cleanEnglishOnly(e.target.value),
                  }));
                }}
                size="small"
              />
            )}

            <TextField
              id="bowelDisturbance"
              name="bowelDisturbance"
              select
              label="Bowel Disturbance"
              variant="outlined"
              size="small"
              sx={{ backgroundColor: "#3071FF21" }}
              value={
                toggle.bowelDisturbance ? "yes" : systemic.bowelDisturbance
              }
              onChange={(e) => {
                const value = e.target.value;
                if (value === "yes") {
                  setToggle((prevToggle) => ({
                    ...prevToggle,
                    bowelDisturbance: true,
                  }));
                  setSystemic((prevBirth) => ({
                    ...prevBirth,
                    bowelDisturbance: "",
                  }));
                } else {
                  setToggle((prevToggle) => ({
                    ...prevToggle,
                    bowelDisturbance: false,
                  }));
                  setSystemic((prevBirth) => ({
                    ...prevBirth,
                    bowelDisturbance: "no",
                  }));
                }
              }}
            >
              {twoValues.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
            {toggle.bowelDisturbance && (
              <TextField
                id="bowelDisturbance"
                name="bowelDisturbance"
                label="Specify Bowel Disturbance"
                variant="outlined"
                value={systemic.bowelDisturbance}
                onChange={(e) => {
                  setSystemic((prev) => ({
                    ...prev,
                    bowelDisturbance: cleanEnglishOnly(e.target.value),
                  }));
                }}
                size="small"
              />
            )}
          </div>
          <h2 className="neurological">Neurological</h2>
          <div className="systemicFormSection">
            <FormControl size="small" sx={{ backgroundColor: "#3071FF21" }}>
              <InputLabel id="tone">Tone</InputLabel>
              <Select
                labelId="tone-select"
                id="tome-select"
                multiple
                value={systemic.tone}
                onChange={(e) => {
                  setSystemic((prev) => ({
                    ...prev,
                    tone: e.target.value,
                  }));
                }}
                input={<OutlinedInput label="Tone" />}
                renderValue={(selected) => selected.join(", ")}
                MenuProps={MenuProps}
              >
                {toneValues.map((name) => (
                  <MenuItem key={name} value={name}>
                    <Checkbox checked={systemic.tone.includes(name)} />
                    <ListItemText primary={name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {ageGroup === "A" && (
              <>
                <FormControl size="small" sx={{ backgroundColor: "#3071FF21" }}>
                  <InputLabel id="neonatal-reflexes-label">
                    Neonatal Reflexes
                  </InputLabel>
                  <Select
                    labelId="neonatal-reflexes-select"
                    id="neonatal-reflexes"
                    name="neonatal-reflexes"
                    multiple
                    value={systemic.neonatalReflexes}
                    onChange={(e) => {
                      setSystemic((prev) => ({
                        ...prev,
                        neonatalReflexes: e.target.value,
                      }));
                    }}
                    input={<OutlinedInput label="Neonatal Reflexes" />}
                    renderValue={(selected) => selected.join(", ")}
                    MenuProps={MenuProps}
                  >
                    {nenotalReflexValues.map((name) => (
                      <MenuItem key={name} value={name}>
                        <Checkbox
                          checked={systemic.neonatalReflexes.includes(name)}
                        />
                        <ListItemText primary={name} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </>
            )}

            {ageGroup !== "A" && (
              <>
                <FormControl size="small" sx={{ backgroundColor: "#3071FF21" }}>
                  <InputLabel id="reflexes">Reflexes</InputLabel>
                  <Select
                    labelId="reflexes-select"
                    id="neonatalReflexes"
                    name="neonatalReflexes"
                    multiple
                    value={systemic.neonatalReflexes}
                    onChange={(e) => {
                      setSystemic((prev) => ({
                        ...prev,
                        neonatalReflexes: e.target.value,
                      }));
                    }}
                    input={<OutlinedInput label="Neonatal Reflexes" />}
                    renderValue={(selected) => selected.join(", ")}
                    MenuProps={MenuProps}
                  >
                    {reflexesValues.map((name) => (
                      <MenuItem key={name} value={name}>
                        <Checkbox
                          checked={systemic.neonatalReflexes.includes(name)}
                        />
                        <ListItemText primary={name} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </>
            )}

            {ageGroup !== "A" && (
              <>
                <FormControl size="small" sx={{ backgroundColor: "#3071FF21" }}>
                  <InputLabel id="power-label">Power</InputLabel>
                  <Select
                    labelId="power-select"
                    id="power"
                    name="power"
                    multiple
                    value={systemic.power}
                    onChange={(e) => {
                      setSystemic((prev) => ({
                        ...prev,
                        power: e.target.value,
                      }));
                    }}
                    input={<OutlinedInput label="Power" />}
                    renderValue={(selected) => selected.join(", ")}
                    MenuProps={MenuProps}
                  >
                    {powerValues.map((name) => (
                      <MenuItem key={name} value={name}>
                        <Checkbox checked={systemic.power.includes(name)} />
                        <ListItemText primary={name} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </>
            )}
          </div>{" "}
        </>
      )}
      <div className="spiltSectionOwnDiv">
        <h2>Vision</h2>

        {ageGroup === "A" && (
          <div className={"systemicVisionSection"}>
            <TextField
              id="redReflex"
              name="redReflex"
              label="Red Reflex"
              variant="outlined"
              size="small"
              value={systemic.redReflex}
              onChange={(e) => {
                setSystemic((prev) => ({
                  ...prev,
                  redReflex: cleanEnglishOnly(e.target.value),
                }));
              }}
            />
            <TextField
              id="ropScreen"
              name="ropScreen"
              label="Rop Screen"
              variant="outlined"
              size="small"
              value={systemic.ropScreen}
              onChange={(e) => {
                setSystemic((prev) => ({
                  ...prev,
                  ropScreen: cleanEnglishOnly(e.target.value),
                }));
              }}
            />
          </div>
        )}
        <div className={"systemicVisionSection"}>
          {(ageGroup !== "A" && ageGroup !== "J")&& (
            <FormControl size="small" sx={{ backgroundColor: "#3071FF21" }}>
              <InputLabel id="power-label">Vision</InputLabel>
              <Select
                labelId="vison-select"
                id="vision"
                name="vision"
                size="small"
                multiple
                value={systemic.visionArray}
                onChange={(e) => {
                  setSystemic((prev) => ({
                    ...prev,
                    visionArray: e.target.value,
                  }));
                }}
                input={<OutlinedInput label="Vision" />}
                renderValue={(selected) => selected.join(", ")}
                MenuProps={MenuProps}
              >
                {(ageGroup === "C" || ageGroup === "B") &&
                  visionValuesC.map((name) => (
                    <MenuItem key={name} value={name}>
                      <Checkbox checked={systemic.visionArray.includes(name)} />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                {ageGroup === "D" &&
                  visionValuesD.map((name) => (
                    <MenuItem key={name} value={name}>
                      <Checkbox checked={systemic.visionArray.includes(name)} />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                {ageGroup === "E" &&
                  visionValuesE.map((name) => (
                    <MenuItem key={name} value={name}>
                      <Checkbox checked={systemic.visionArray.includes(name)} />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                {ageGroup === "F" &&
                  visionValuesF.map((name) => (
                    <MenuItem key={name} value={name}>
                      <Checkbox checked={systemic.visionArray.includes(name)} />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                {ageGroup === "G" &&
                  visionValuesG.map((name) => (
                    <MenuItem key={name} value={name}>
                      <Checkbox checked={systemic.visionArray.includes(name)} />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                {ageGroup === "H" &&
                  visionValuesH.map((name) => (
                    <MenuItem key={name} value={name}>
                      <Checkbox checked={systemic.visionArray.includes(name)} />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                {ageGroup === "I" &&
                  visionValuesI.map((name) => (
                    <MenuItem key={name} value={name}>
                      <Checkbox checked={systemic.visionArray.includes(name)} />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          )}
          {ageGroup === "J" && (
            <TextField
          id="routineEyeCheckup"
          name="routineEyeCheckup"
          select
          label="Routine Eye Check done?"
          variant="outlined"
          size="small"
          sx={{ backgroundColor: "#3071FF21" }}
          value={systemic.routineEyeCheckup}
          onChange={(e) => {
            const val = e.target.value;
            setSystemic((prev) => ({
              ...prev,
              routineEyeCheckup: val,
            }));
          }}
        >
          {twoValues.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
          )}
        </div>
      </div>
      <div className="spiltSectionOwnDiv">
        <h2>Hearing</h2>
        <div className={"systemicVisionSection"}>
          {ageGroup === "A" && (
            <TextField
              id="oae"
              name="oae"
              label="OAE / BERA"
              variant="outlined"
              size="small"
              value={systemic.oae}
              onChange={(e) => {
                setSystemic((prev) => ({
                  ...prev,
                  oae: cleanEnglishOnly(e.target.value),
                }));
              }}
            />
          )}

          {ageGroup !== "A" && (
            <>
              <FormControl size="small" sx={{ backgroundColor: "#3071FF21" }}>
                <InputLabel id="hearing-label">Hearing</InputLabel>
                <Select
                  labelId="hearing-select"
                  id="hearing"
                  name="hearing"
                  multiple
                  value={systemic.hearingArray}
                  onChange={(e) => {
                    setSystemic((prev) => ({
                      ...prev,
                      hearingArray: e.target.value,
                    }));
                  }}
                  input={<OutlinedInput label="Hearing" />}
                  renderValue={(selected) => selected.join(", ")}
                  MenuProps={MenuProps}
                >
                  {(ageGroup === "C" || ageGroup === "B") &&
                    hearingValuesC.map((name) => (
                      <MenuItem key={name} value={name}>
                        <Checkbox
                          checked={systemic.hearingArray.includes(name)}
                        />
                        <ListItemText primary={name} />
                      </MenuItem>
                    ))}
                  {ageGroup === "D" &&
                    hearingValuesD.map((name) => (
                      <MenuItem key={name} value={name}>
                        <Checkbox
                          checked={systemic.hearingArray.includes(name)}
                        />
                        <ListItemText primary={name} />
                      </MenuItem>
                    ))}
                  {ageGroup === "E" &&
                    hearingValuesE.map((name) => (
                      <MenuItem key={name} value={name}>
                        <Checkbox
                          checked={systemic.hearingArray.includes(name)}
                        />
                        <ListItemText primary={name} />
                      </MenuItem>
                    ))}
                  {ageGroup === "F" &&
                    hearingValuesF.map((name) => (
                      <MenuItem key={name} value={name}>
                        <Checkbox
                          checked={systemic.hearingArray.includes(name)}
                        />
                        <ListItemText primary={name} />
                      </MenuItem>
                    ))}
                  {(ageGroup === "G" || ageGroup === "H" || ageGroup === "I" || ageGroup === "J") &&
                    hearingValuesG.map((name) => (
                      <MenuItem key={name} value={name}>
                        <Checkbox
                          checked={systemic.hearingArray.includes(name)}
                        />
                        <ListItemText primary={name} />
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </>
          )}
        </div>
      </div>
    </div>
  );

  let feedingStatus = (
    <div className="formMain">
      <div>
        <h2>Nutrition</h2>
      </div>
      {(ageGroup === "A" || ageGroup === "B") && (
        <div className="feedingFormSection">
          <TextField
            id="breastFeeding"
            name="breastFeeding"
            select
            label="Breast Feeding"
            variant="outlined"
            size="small"
            sx={{ backgroundColor: "#3071FF21" }}
            value={nutriton.breastFeeding}
            onChange={(e) => {
              const val = e.target.value;
              setNutrition((prev) => ({
                ...prev,
                breastFeeding: val,
              }));
            }}
          >
            {breastfeedingValues.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            id="feedingTechnique"
            name="feedingTechnique"
            select
            label="Feeding Technique"
            variant="outlined"
            size="small"
            sx={{ backgroundColor: "#3071FF21" }}
            value={nutriton.feedingTechnique}
            onChange={(e) => {
              const val = e.target.value;
              setNutrition((prev) => ({
                ...prev,
                feedingTechnique: val,
              }));
            }}
          >
            {feedingTeachniqueValues.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </div>
      )}
      {(ageGroup === "C" || ageGroup === "D") && (
        <div className="feedingFormSection">
          <TextField
            size="small"
            select
            name="complimentaryFeedingAdequate"
            label="Complimentary feeding adequate ?"
            value={nutriton.complimentaryFeedingAdequate}
            sx={{
              backgroundColor: "#3071FF21",
            }}
            onChange={(e) => {
              setNutrition((prev) => ({
                ...prev,
                complimentaryFeedingAdequate: e.target.value,
              }));
            }}
          >
            {yesNoOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            id="feedingPlan"
            name="feeding Plan"
            label="Feeding Plan"
            variant="outlined"
            size="small"
            value={nutriton.feedingPlan}
            onChange={(e) => {
              const val = e.target.value;
              setNutrition((prev) => ({
                ...prev,
                feedingPlan: cleanEnglishOnly(val),
              }));
            }}
          />
        </div>
      )}

      {(ageGroup === "E" || ageGroup === "F") && (
        <div className="formSection">
          <NumberInput
            id="numberOfMeals"
            name="numberOfMeals"
            label="Number of meals"
            value={nutriton.numberOfMeals}
            onChange={handleNutritionChange}
          />
        </div>
      )}
      {(ageGroup === "E" ||
        ageGroup === "F" ||
        ageGroup === "G" ||
        ageGroup === "H" ||
        ageGroup === "I" ||
        ageGroup === "J") && (
        <div className="agegroupEtoI">
          <TextField
            label="Complimentary feeding adequate ?"
            name="complimentaryFeedingAdequate"
            size="small"
            select
            sx={{
              backgroundColor: "#3071FF21",
            }}
            value={nutriton.complimentaryFeedingAdequate}
            onChange={(e) => {
              setNutrition((prev) => ({
                ...prev,
                complimentaryFeedingAdequate: cleanEnglishOnly(e.target.value),
              }));
            }}
          >
            {yesNoOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            sx={{ backgroundColor: "#3071FF21" }}
            id="varietyInFoodItem"
            name="varietyInFoodItem"
            select
            label="Variety in food items"
            variant="outlined"
            size="small"
            value={nutriton.varietyInFoodItem}
            onChange={(e) => {
              const val = e.target.value;
              setNutrition((prev) => ({
                ...prev,
                varietyInFoodItem: val,
              }));
            }}
          >
            {twoValues.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            id="feedingPlan"
            name="feeding Plan"
            label="Feeding Plan"
            variant="outlined"
            size="small"
            value={nutriton.feedingPlan}
            onChange={(e) => {
              const val = e.target.value;
              setNutrition((prev) => ({
                ...prev,
                feedingPlan: cleanEnglishOnly(val),
              }));
            }}
          />
        </div>
      )}
      {/* <div className="formSection">
        <TextField
          id="weightGain"
          name="weightGain"
          select
          label="Weight Gain"
          variant="outlined"
          size="small"
          sx={{
            // width: { sm: "300px", xs: "100%" },
            backgroundColor: "#3071FF21",
          }}
          value={nutriton.weightGain}
          onChange={(e) => {
            const val = e.target.value;
            setNutrition((prev) => ({
              ...prev,
              weightGain: val,
            }));
          }}
        >
          {weightGainValues.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </div> */}
      <div>
        <h2>Safety / Security</h2>
      </div>
      <div className="systemicFormSection">
        <TextField
          id="babyProofing"
          name="babyProofing"
          select
          label="Baby Proofing"
          variant="outlined"
          size="small"
          sx={{ backgroundColor: "#3071FF21" }}
          value={toggle.babyProofing ? "inadequate" : nutriton.babyProofing}
          onChange={(e) => {
            const value = e.target.value;
            if (value === "inadequate") {
              setToggle((prevToggle) => ({
                ...prevToggle,
                babyProofing: true,
              }));
              setNutrition((prevBirth) => ({
                ...prevBirth,
                babyProofing: "",
              }));
            } else {
              setToggle((prevToggle) => ({
                ...prevToggle,
                babyProofing: false,
              }));
              setNutrition((prevBirth) => ({
                ...prevBirth,
                babyProofing: "adequate",
              }));
            }
          }}
        >
          {babyProofingValues.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
        {toggle.babyProofing && (
          <TextField
            id="babyProofing"
            name="babyProofing"
            label="Specify Baby Proofing"
            variant="outlined"
            value={nutriton.babyProofing}
            onChange={(e) => {
              setNutrition((prev) => ({
                ...prev,
                babyProofing: cleanEnglishOnly(e.target.value),
              }));
            }}
            size="small"
          />
        )}
        <TextField
          id="signsOfNeglect"
          name="signsOfNeglect"
          select
          label="Signs Of Neglect"
          variant="outlined"
          size="small"
          sx={{ backgroundColor: "#3071FF21" }}
          value={toggle.signsOfNeglect ? "yes" : nutriton.signsOfNeglect}
          onChange={(e) => {
            const value = e.target.value;
            if (value === "yes") {
              setToggle((prevToggle) => ({
                ...prevToggle,
                signsOfNeglect: true,
              }));
              setNutrition((prevBirth) => ({
                ...prevBirth,
                signsOfNeglect: "",
              }));
            } else {
              setToggle((prevToggle) => ({
                ...prevToggle,
                signsOfNeglect: false,
              }));
              setNutrition((prevBirth) => ({
                ...prevBirth,
                signsOfNeglect: "no",
              }));
            }
          }}
        >
          {twoValues.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
        {toggle.signsOfNeglect && (
          <TextField
            id="signsOfNeglect"
            name="signsOfNeglect"
            label="Specify Signs Of Neglect"
            variant="outlined"
            value={nutriton.signsOfNeglect}
            onChange={(e) => {
              setNutrition((prev) => ({
                ...prev,
                signsOfNeglect: cleanEnglishOnly(e.target.value),
              }));
            }}
            size="small"
          />
        )}
      </div>
      {ageGroup !== "A" && ageGroup !== "B" && ageGroup !== "C" && (
        <div className="formSection">
          <TextField
            id="safeToys"
            name="safeToys"
            select
            label="Safe Toys"
            variant="outlined"
            size="small"
            sx={{
              backgroundColor: "#3071FF21",
            }}
            value={nutriton.safeToys}
            onChange={(e) => {
              const val = e.target.value;
              setNutrition((prev) => ({
                ...prev,
                safeToys: val,
              }));
            }}
          >
            {twoValues.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </div>
      )}
      {/* modified */}
      {(ageGroup === "H" || ageGroup === "I" || ageGroup === "J") && (
        <div className="feedingFormSection">
          <TextField
            id="adequateSupervision"
            name="adequateSupervision"
            select
            label="Adequate Supervision"
            variant="outlined"
            size="small"
            sx={{ backgroundColor: "#3071FF21" }}
            value={nutriton.adequateSupervision}
            onChange={(e) => {
              const val = e.target.value;
              setNutrition((prev) => ({
                ...prev,
                adequateSupervision: val,
              }));
            }}
          >
            {twoValues.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            id="anysafetyIssues"
            name="anysafetyIssues"
            label="Any safety Issues"
            variant="outlined"
            size="small"
            value={nutriton.anysafetyIssues}
            onChange={(e) => {
              const val = e.target.value;
              setNutrition((prev) => ({
                ...prev,
                anysafetyIssues: cleanEnglishOnly(val),
              }));
            }}
          />
        </div>
      )}
    </div>
  );

  let checkBoxStatus = (
    <div className={"formMain"}>
      <div className="spiltRow">
        <div className={"checkBoxContainer"}>
          <h2>Responsive Care Giving</h2>
          <div className="sectionRow">
            <FormControl size="small" sx={{ backgroundColor: "#3071FF21" }}>
              <InputLabel id="tone">
                How do parents interact with the baby ?
              </InputLabel>
              <Select
                labelId="responsive-care-giving-label"
                id="responsive-car-giving"
                multiple
                size="small"
                fullWidth
                value={checker.responsiveCareGiving}
                onChange={(e) => {
                  setChecker((prev) => ({
                    ...prev,
                    responsiveCareGiving: e.target.value,
                  }));
                }}
                input={
                  <OutlinedInput label="How do parents interact with the baby ?" />
                }
                renderValue={(selected) => selected.join(", ")}
                MenuProps={MenuProps}
              >
                {ageGroup === "A" &&
                  responsiveCareGivingValuesA.map((name) => (
                    <MenuItem key={name} value={name} sx={{ width: 400 }}>
                      <Checkbox
                        checked={checker.responsiveCareGiving.includes(name)}
                      />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                {ageGroup === "B" &&
                  responsiveCareGivingValuesB.map((name) => (
                    <MenuItem key={name} value={name} sx={{ width: 400 }}>
                      <Checkbox
                        checked={checker.responsiveCareGiving.includes(name)}
                      />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                {ageGroup === "C" &&
                  responsiveCareGivingValuesC.map((name) => (
                    <MenuItem key={name} value={name} sx={{ width: 400 }}>
                      <Checkbox
                        checked={checker.responsiveCareGiving.includes(name)}
                      />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                {ageGroup === "D" &&
                  responsiveCareGivingValuesD.map((name) => (
                    <MenuItem key={name} value={name} sx={{ width: 400 }}>
                      <Checkbox
                        checked={checker.responsiveCareGiving.includes(name)}
                      />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                {ageGroup === "E" &&
                  responsiveCareGivingValuesE.map((name) => (
                    <MenuItem key={name} value={name} sx={{ width: 400 }}>
                      <Checkbox
                        checked={checker.responsiveCareGiving.includes(name)}
                      />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                {ageGroup === "F" &&
                  responsiveCareGivingValuesF.map((name) => (
                    <MenuItem key={name} value={name} sx={{ width: 400 }}>
                      <Checkbox
                        checked={checker.responsiveCareGiving.includes(name)}
                      />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                {ageGroup === "G" &&
                  responsiveCareGivingValuesG.map((name) => (
                    <MenuItem key={name} value={name} sx={{ width: 400 }}>
                      <Checkbox
                        checked={checker.responsiveCareGiving.includes(name)}
                      />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                {ageGroup === "H" &&
                  responsiveCareGivingValuesH.map((name) => (
                    <MenuItem key={name} value={name} sx={{ width: 400 }}>
                      <Checkbox
                        checked={checker.responsiveCareGiving.includes(name)}
                      />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                {ageGroup === "I" &&
                  responsiveCareGivingValuesI.map((name) => (
                    <MenuItem key={name} value={name} sx={{ width: 400 }}>
                      <Checkbox
                        checked={checker.responsiveCareGiving.includes(name)}
                      />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                {ageGroup === "J" &&
                  responsiveCareGivingValuesJ.map((name) => (
                    <MenuItem key={name} value={name} sx={{ width: 400 }}>
                      <Checkbox
                        checked={checker.responsiveCareGiving.includes(name)}
                      />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </div>
        </div>
        <div className="checkBoxContainer">
          <h2>Early Learning Opportunity</h2>
          <div className="sectionRow">
            <FormControl size="small" sx={{ backgroundColor: "#3071FF21" }}>
              <InputLabel id="ealeopp">Early Learning Opportunity</InputLabel>
              <Select
                labelId="early-learning-opp-label"
                id="early-learning-opp-giving"
                multiple
                size="small"
                value={checker.earlyLearningOppertunity}
                onChange={(e) => {
                  setChecker((prev) => ({
                    ...prev,
                    earlyLearningOppertunity: e.target.value,
                  }));
                }}
                input={<OutlinedInput label="Early Learning Oppertunity" />}
                renderValue={(selected) => selected.join(", ")}
                MenuProps={MenuProps}
              >
                {ageGroup === "A" &&
                  earlyLearningOppertunityValuesA.map((name) => (
                    <MenuItem key={name} value={name} sx={{ width: 500 }}>
                      <Checkbox
                        checked={checker.earlyLearningOppertunity.includes(
                          name
                        )}
                      />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                {ageGroup === "B" &&
                  earlyLearningOppertunityValuesB.map((name) => (
                    <MenuItem key={name} value={name} sx={{ width: 500 }}>
                      <Checkbox
                        checked={checker.earlyLearningOppertunity.includes(
                          name
                        )}
                      />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                {ageGroup === "C" &&
                  earlyLearningOppertunityValuesC.map((name) => (
                    <MenuItem key={name} value={name} sx={{ width: 500 }}>
                      <Checkbox
                        checked={checker.earlyLearningOppertunity.includes(
                          name
                        )}
                      />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                {ageGroup === "D" &&
                  earlyLearningOppertunityValuesD.map((name) => (
                    <MenuItem key={name} value={name} sx={{ width: 500 }}>
                      <Checkbox
                        checked={checker.earlyLearningOppertunity.includes(
                          name
                        )}
                      />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                {ageGroup === "E" &&
                  earlyLearningOppertunityValuesE.map((name) => (
                    <MenuItem key={name} value={name} sx={{ width: 500 }}>
                      <Checkbox
                        checked={checker.earlyLearningOppertunity.includes(
                          name
                        )}
                      />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                {ageGroup === "F" &&
                  earlyLearningOppertunityValuesF.map((name) => (
                    <MenuItem key={name} value={name} sx={{ width: 500 }}>
                      <Checkbox
                        checked={checker.earlyLearningOppertunity.includes(
                          name
                        )}
                      />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                {ageGroup === "G" &&
                  earlyLearningOppertunityValuesG.map((name) => (
                    <MenuItem key={name} value={name} sx={{ width: 500 }}>
                      <Checkbox
                        checked={checker.earlyLearningOppertunity.includes(
                          name
                        )}
                      />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                {ageGroup === "H" &&
                  earlyLearningOppertunityValuesH.map((name) => (
                    <MenuItem key={name} value={name} sx={{ width: 500 }}>
                      <Checkbox
                        checked={checker.earlyLearningOppertunity.includes(
                          name
                        )}
                      />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                {ageGroup === "I" &&
                  earlyLearningOppertunityValuesI.map((name) => (
                    <MenuItem key={name} value={name} sx={{ width: 500 }}>
                      <Checkbox
                        checked={checker.earlyLearningOppertunity.includes(
                          name
                        )}
                      />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                {ageGroup === "J" &&
                  earlyLearningOppertunityValuesJ.map((name) => (
                    <MenuItem key={name} value={name} sx={{ width: 500 }}>
                      <Checkbox
                        checked={checker.earlyLearningOppertunity.includes(
                          name
                        )}
                      />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </div>
        </div>
        <div className="checkBoxContainer">
          <h2>Any Red Flags ?</h2>
          <div className="sectionRow">
            <FormControl size="small" sx={{ backgroundColor: "#3071FF21" }}>
              <InputLabel id="ealeopp">Any Red Flags ?</InputLabel>
              <Select
                labelId="anyRedFlags-label"
                id="anyRedFlags"
                name="anyRedFlags"
                multiple
                size="small"
                value={checker.anyRedFlags}
                onChange={(e) => {
                  setChecker((prev) => ({
                    ...prev,
                    anyRedFlags: e.target.value,
                  }));
                }}
                input={<OutlinedInput label="any Red Flags ?" />}
                renderValue={(selected) => selected.join(", ")}
                MenuProps={MenuProps}
              >
                {ageGroup === "A" &&
                  anyRedFlagValuesA.map((name) => (
                    <MenuItem key={name} value={name} sx={{ width: 400 }}>
                      <Checkbox checked={checker.anyRedFlags.includes(name)} />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                {ageGroup === "B" &&
                  anyRedFlagValuesB.map((name) => (
                    <MenuItem key={name} value={name} sx={{ width: 400 }}>
                      <Checkbox checked={checker.anyRedFlags.includes(name)} />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                {ageGroup === "C" &&
                  anyRedFlagValuesC.map((name) => (
                    <MenuItem key={name} value={name} sx={{ width: 400 }}>
                      <Checkbox checked={checker.anyRedFlags.includes(name)} />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                {ageGroup === "D" &&
                  anyRedFlagValuesD.map((name) => (
                    <MenuItem key={name} value={name} sx={{ width: 400 }}>
                      <Checkbox checked={checker.anyRedFlags.includes(name)} />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                {ageGroup === "E" &&
                  anyRedFlagValuesE.map((name) => (
                    <MenuItem key={name} value={name} sx={{ width: 400 }}>
                      <Checkbox checked={checker.anyRedFlags.includes(name)} />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                {ageGroup === "F" &&
                  anyRedFlagValuesF.map((name) => (
                    <MenuItem key={name} value={name} sx={{ width: 400 }}>
                      <Checkbox checked={checker.anyRedFlags.includes(name)} />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                {ageGroup === "G" &&
                  anyRedFlagValuesG.map((name) => (
                    <MenuItem key={name} value={name} sx={{ width: 400 }}>
                      <Checkbox checked={checker.anyRedFlags.includes(name)} />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                {ageGroup === "H" &&
                  anyRedFlagValuesH.map((name) => (
                    <MenuItem key={name} value={name} sx={{ width: 400 }}>
                      <Checkbox checked={checker.anyRedFlags.includes(name)} />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                {ageGroup === "I" &&
                  anyRedFlagValuesI.map((name) => (
                    <MenuItem key={name} value={name} sx={{ width: 400 }}>
                      <Checkbox checked={checker.anyRedFlags.includes(name)} />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                {ageGroup === "J" &&
                  anyRedFlagValuesJ.map((name) => (
                    <MenuItem key={name} value={name} sx={{ width: 400 }}>
                      <Checkbox checked={checker.anyRedFlags.includes(name)} />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </div>
        </div>
      </div>
    </div>
  );

  let impressionStatus = (
    <div className={"formMain"}>
      <div>
        <h2>Impression</h2>
      </div>
      <div className="impressionFormSection">
        <TextField
          id="difficultyInMovement"
          name="difficultyInMovement"
          select
          label="Difficulty In Movement"
          variant="outlined"
          size="small"
          sx={{ backgroundColor: "#3071FF21" }}
          value={impression.difficultyInMovement}
          onChange={(e) => {
            const val = e.target.value;
            setImpression((prev) => ({
              ...prev,
              difficultyInMovement: val,
            }));
          }}
        >
          {twoValues.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          id="stiffnessOfBody"
          name="stiffnessOfBody"
          select
          label="Stiffness Of Body"
          variant="outlined"
          size="small"
          sx={{ backgroundColor: "#3071FF21" }}
          value={impression.stiffnessOfBody}
          onChange={(e) => {
            const val = e.target.value;
            setImpression((prev) => ({
              ...prev,
              stiffnessOfBody: val,
            }));
          }}
        >
          {twoValues.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>{" "}
        <TextField
          id="seizures"
          name="seizures"
          select
          label="Seizures"
          variant="outlined"
          size="small"
          sx={{ backgroundColor: "#3071FF21" }}
          value={impression.seizures}
          onChange={(e) => {
            const val = e.target.value;
            setImpression((prev) => ({
              ...prev,
              seizures: val,
            }));
          }}
        >
          {twoValues.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          id="impairedVision"
          name="impairedVision"
          select
          label="Impaired Vision"
          variant="outlined"
          size="small"
          sx={{ backgroundColor: "#3071FF21" }}
          value={impression.impairedVision}
          onChange={(e) => {
            const val = e.target.value;
            setImpression((prev) => ({
              ...prev,
              impairedVision: val,
            }));
          }}
        >
          {twoValues.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          id="impairedHearing"
          name="impairedHearing"
          select
          label="Impaired Hearing"
          variant="outlined"
          size="small"
          sx={{ backgroundColor: "#3071FF21" }}
          value={impression.impairedHearing}
          onChange={(e) => {
            const val = e.target.value;
            setImpression((prev) => ({
              ...prev,
              impairedHearing: val,
            }));
          }}
        >
          {twoValues.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          id="regressionOfMilestones"
          name="regressionOfMilestones"
          select
          label="Regression of milestones"
          variant="outlined"
          size="small"
          sx={{ backgroundColor: "#3071FF21" }}
          value={impression.regressionOfMilestones}
          onChange={(e) => {
            const val = e.target.value;
            setImpression((prev) => ({
              ...prev,
              regressionOfMilestones: val,
            }));
          }}
        >
          {twoValues.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </div>
      <div className="impressionLastSection">
        {ageGroup !== "A" && (
          <>
            <TextField
              id="delayedMilestones"
              name="delayedMilestones"
              select
              label="Delayed Milstones"
              variant="outlined"
              size="small"
              sx={{ backgroundColor: "#3071FF21" }}
              value={impression.delayedMilestones}
              onChange={(e) => {
                const val = e.target.value;
                setImpression((prev) => ({
                  ...prev,
                  delayedMilestones: val,
                }));
              }}
            >
              {twoValues.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </>
        )}

        <TextField
          id="comments"
          name="comments"
          label="Comments"
          variant="outlined"
          size="small"
          sx={{ backgroundColor: "#3071FF21" }}
          value={impression.comments}
          onChange={(e) => {
            const val = e.target.value;
            setImpression((prev) => ({
              ...prev,
              comments: cleanEnglishOnly(val),
            }));
          }}
        />
        <div className="calender">
          <BasicDatePicker
            value={impression.followUpDate}
            label={"Next Appointment"}
            onChange={(value) =>
              setImpression((imp) => ({ ...imp, followUpDate: value }))
            }
          />
          {impression.followUpDate && (
            <span
              className="clear-calender"
              onClick={() =>
                setImpression((prev) => ({ ...prev, followUpDate: null }))
              }
            >
              X
            </span>
          )}
        </div>
      </div>
    </div>
  );

  return (
    <div className={"main"}>
      <Loader isLoading={loading} />
      <div className="headerContainer">
        <button
          className="backButton"
          onClick={() => navigate(`/new-patient-profile/${id}/${docId}`)}
        >
          <FontAwesomeIcon className="icon" icon={faArrowLeft} />
          <span>Back to Patient Profile</span>
        </button>
        <h1 className="heading">Wellness Record Form</h1>
        {(step === VISITRECORDSTATE.MILSTONE ||
          step === VISITRECORDSTATE.IMMUNIZATION) && (
          <div className={"buttonDiv conditionalbtns"}>
            {secondaryActionLabel && (
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "black",
                  color: "white",
                  "&:hover": { backgroundColor: "#333" },
                }}
                size="large"
                onClick={decrementStep}
              >
                {secondaryActionLabel}
              </Button>
            )}

            {actionLabel && (
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "black",
                  color: "white",
                  "&:hover": { backgroundColor: "#333" },
                }}
                size="large"
                onClick={incrementStep}
              >
                {actionLabel}
              </Button>
            )}
          </div>
        )}
      </div>
      <div className={"form"}>
        {step === VISITRECORDSTATE.ANTHROPOMETRY && anthropometry}
        {step === VISITRECORDSTATE.MILSTONE && (
          <MilestoneTrackerDoctorView
            pediatricianId={docId}
            patientId={id}
            parentId={parentId}
            childId={childId}
          />
        )}
        {step === VISITRECORDSTATE.IMMUNIZATION && (
          <VaccinationTrackerDoctorView pediatricianId={docId} patientId={id} />
        )}
        {step === VISITRECORDSTATE.MCHAT && (
          <MChat
            setMchatAnsCount={setMchatAnsCount}
            handleAnswerChange={handleAnswerChange}
            answers={answers}
            setAnswers={setAnswers}
            setMchatScore={setMchatScore}
            id={id}
            docId={docId}
          />
        )}
        {step === VISITRECORDSTATE.HEALTHSTATUS && healthStatus}
        {step === VISITRECORDSTATE.SYSTEMIC && systemicStatus}
        {step === VISITRECORDSTATE.NUTRITION && feedingStatus}
        {step === VISITRECORDSTATE.CHECKBOXES && checkBoxStatus}
        {step === VISITRECORDSTATE.IMPRESSION && impressionStatus}
        <div className={"buttonDiv"}>
          {secondaryActionLabel && (
            <Button
              variant="contained"
              sx={{
                backgroundColor: "black",
                color: "white",
                "&:hover": { backgroundColor: "#333" },
              }}
              size="large"
              onClick={decrementStep}
            >
              {secondaryActionLabel}
            </Button>
          )}

          {actionLabel && (
            <Button
              variant="contained"
              sx={{
                backgroundColor: "black",
                color: "white",
                "&:hover": { backgroundColor: "#333" },
              }}
              size="large"
              onClick={incrementStep}
            >
              <pre className="next-visit-btn">{actionLabel}</pre>
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default NewAddVisitRecordForm;
